module.exports = __webpack_public_path__ + "img/localinfo.6af06993.png";